<mat-select
  [value]="identification()?.deviceId ?? 'NOT_IDENTIFIED'"
  (selectionChange)="onSelect($event.value)"
  [disabled]="disabled()"
  class="rma-device-select"
>
  <mat-select-trigger>
    <span
      class="rma-device-trigger"
      [class.state-identified]="identification()?.state === 'IDENTIFIED'"
      [class.state-waiting]="
        identification()?.state === 'WAITING' ||
        (isComplete() && identification()?.state === 'NOT_IDENTIFIED')
      "
      [class.state-not-identified]="!isComplete() && identification()?.state === 'NOT_IDENTIFIED'"
    >
      @if (identification()?.state === 'IDENTIFIED') {
        <span class="device-id">{{ identification()?.deviceId }}</span>
      } @else if (
        identification()?.state === 'WAITING' && identification()?.parsedDeviceId;
        as parsedId
      ) {
        <span class="device-id">{{ parsedId }}</span>
        <span class="device-type"> waiting for connection</span>
      } @else {
        <span class="device-id">Not Identified</span>
      }
    </span>
  </mat-select-trigger>

  <mat-option [value]="'NOT_IDENTIFIED'">Not Identified</mat-option>
  <mat-option [value]="'MANUAL'">Manual Identification</mat-option>
  @for (device of availableDevices(); track device.deviceId) {
    <mat-option [value]="device.deviceId" [disabled]="device.disabled">
      {{ device.label }}
    </mat-option>
  }
</mat-select>
